export const editFormName = "editDetails";
export const dataLocalStorageKey = "details";

export const initialDetails = {
  firstName: "Joe",
  lastName: "Schmoe",
  email: "",
  address: "",
  phone: "",
  website: "",
  education: [],
  experience: [],
  skills: [],
  honors: []
};



// WEBPACK FOOTER //
// ./src/consts.js